const globalAdState = {
    isAdMounted: false,
    hasIdSyncEvaluated: false,
    isLoadedInOtherPivot: false,
};

export const updateIsAdMounted = (isAdMounted: boolean) => {
    globalAdState.isAdMounted = isAdMounted;
};

export const resetGlobalAdState = () => {
    globalAdState.isAdMounted = false;
    globalAdState.isLoadedInOtherPivot = false;
};

export const updateLoadedInOtherPivot = (isLoadedInOtherPivot: boolean) => {
    globalAdState.isLoadedInOtherPivot = isLoadedInOtherPivot;
};

export const setIdAlreadyEvaluated = () => {
    globalAdState.hasIdSyncEvaluated = true;
};

const getGlobalAdState = () => globalAdState;

export default getGlobalAdState;
